/**
 * Interface for Premium Plan feature settings
 */ /**
 * Enum for user access type in premium plan
 */ export var PremiumPlanUserAccessTypes = /*#__PURE__*/ function(PremiumPlanUserAccessTypes) {
    PremiumPlanUserAccessTypes["noAccess"] = "noAccess";
    PremiumPlanUserAccessTypes["readOnly"] = "readOnly";
    PremiumPlanUserAccessTypes["restrictedReadWrite"] = "restrictedReadWrite";
    PremiumPlanUserAccessTypes["readWrite"] = "readWrite";
    return PremiumPlanUserAccessTypes;
}({});
/**
 * Enum for premium plan feature access status
 */ export var PremiumPlanAccessStatuses = /*#__PURE__*/ function(PremiumPlanAccessStatuses) {
    PremiumPlanAccessStatuses["none"] = "none";
    PremiumPlanAccessStatuses["noModProjLicenseInTenant"] = "noModProjLicenseInTenant";
    PremiumPlanAccessStatuses["noRoadmapLicenseInTenant"] = "noRoadmapLicenseInTenant";
    PremiumPlanAccessStatuses["p1ProjectOnlineEssentials"] = "p1ProjectOnlineEssentials";
    return PremiumPlanAccessStatuses;
}({});
/**
 * User's current premium plan license level.
 */ export var PremiumPlanLicenseLevel = /*#__PURE__*/ function(PremiumPlanLicenseLevel) {
    PremiumPlanLicenseLevel["basic"] = "basic";
    PremiumPlanLicenseLevel["basicPlus"] = "basicPlus";
    PremiumPlanLicenseLevel["standard"] = "standard";
    PremiumPlanLicenseLevel["professional"] = "professional";
    PremiumPlanLicenseLevel["premium"] = "premium";
    return PremiumPlanLicenseLevel;
}({});
/**
 * Enum representing O365 category based on user service plans:
 * - If any feature's category is "Commercial," O365 category is "Commercial."
 * - If all features have category "Commercial Education," O365 category is "Commercial Education."
 * - Undefined category is treated as "Commercial."
 */ export var Office365Category = /*#__PURE__*/ function(Office365Category) {
    Office365Category["commercial"] = "Commercial";
    Office365Category["commercialEducation"] = "Commercial Education";
    return Office365Category;
}({});
/**
 * Predefined user feature entitlements context with no access to any features.
 */ export const NoAccessToFeatures = {
    exchange: {
        accessType: "noAccess",
        accessStatus: "none"
    },
    roadmap: {
        accessType: "noAccess",
        accessStatus: "none"
    },
    premiumPlan: {
        accessType: "noAccess",
        accessStatus: "none"
    },
    projectOnline: {
        accessType: "noAccess",
        accessStatus: "none"
    },
    projectOperations: {
        accessType: "noAccess",
        accessStatus: "none"
    }
};
/**
 * Predefined user feature entitlements context with read-write access to all features.
 */ export const ReadWriteAccessToFeatures = {
    exchange: {
        accessType: "readWrite",
        accessStatus: "none"
    },
    roadmap: {
        accessType: "readWrite",
        accessStatus: "none"
    },
    premiumPlan: {
        accessType: "readWrite",
        accessStatus: "none"
    },
    projectOnline: {
        accessType: "readWrite",
        accessStatus: "none"
    },
    projectOperations: {
        accessType: "readWrite",
        accessStatus: "none"
    }
};
/**
 * Enum for Premium feature types
 */ export var PremiumFeatureTypes = /*#__PURE__*/ function(PremiumFeatureTypes) {
    PremiumFeatureTypes["exchange"] = "exchange";
    PremiumFeatureTypes["roadmap"] = "roadmap";
    PremiumFeatureTypes["premiumPlan"] = "premiumPlan";
    PremiumFeatureTypes["projectOnline"] = "projectOnline";
    PremiumFeatureTypes["projectOperations"] = "projectOperations";
    return PremiumFeatureTypes;
}({});
/**
 * User access type options
 */ export var PremiumPlanUserAccessTypeOptions = /*#__PURE__*/ function(PremiumPlanUserAccessTypeOptions) {
    PremiumPlanUserAccessTypeOptions[PremiumPlanUserAccessTypeOptions["noAccess"] = 0] = "noAccess";
    PremiumPlanUserAccessTypeOptions[PremiumPlanUserAccessTypeOptions["hasAccess"] = 1] = "hasAccess";
    PremiumPlanUserAccessTypeOptions[PremiumPlanUserAccessTypeOptions["restrictedReadWrite"] = 3] = "restrictedReadWrite";
    PremiumPlanUserAccessTypeOptions[PremiumPlanUserAccessTypeOptions["readWrite"] = 2] = "readWrite";
    return PremiumPlanUserAccessTypeOptions;
}({});
/**
 * Predefined user premium plan feature permissions context with no permission to premium plan feature.
 */ export const NoPremiumPlanFeaturePermissions = {
    noAccess: false,
    readonly: false,
    restrictedReadWrite: false,
    readWrite: false
};
